export class PathSnapshotsResponse {
    'data';
    'pagination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<FileSnapshot>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PathSnapshotsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
